import {
    GET_RECEIVABLE_REQUEST, GET_RECEIVABLE_SUCCESS, GET_RECEIVABLE_FAIL,
    CREATE_RECEIVABLE_REQUEST, CREATE_RECEIVABLE_SUCCESS, CREATE_RECEIVABLE_FAIL,
    UPDATE_RECEIVABLE_REQUEST, UPDATE_RECEIVABLE_SUCCESS, UPDATE_RECEIVABLE_FAIL,
    DELETE_RECEIVABLE_REQUEST, DELETE_RECEIVABLE_SUCCESS, DELETE_RECEIVABLE_FAIL
} from "../types/receivableTypes";
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import APP_CONSTANT from '../../config/constants';

export const deleteReceivable = (id) => async (dispatch) => {
    dispatch({ type: DELETE_RECEIVABLE_REQUEST });
    let delRecordId = Buffer.from(id).toString('base64');
    try {
        const { data } = await Axios.delete(`${APP_CONSTANT.BASE_URL}sales/sales-receivables/delete/${delRecordId}`, {
            data: {
                "api_token": localStorage.getItem('apiToken'),
                "customer_no": localStorage.getItem('customerNo'),
                "user_id": localStorage.getItem('userId'),
            },
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_RECEIVABLE_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        dispatch({ type: DELETE_RECEIVABLE_FAIL, payload: error.message })
    }
}

export const updateReceivable = (updateReceivableData) => async (dispatch) => {
    dispatch({ type: UPDATE_RECEIVABLE_REQUEST });
    let rf_number = Buffer.from(updateReceivableData.reference_number).toString('base64');
    try {
        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}sales/sales-receivables/update/${rf_number}`, updateReceivableData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_RECEIVABLE_SUCCESS, payload: data });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/receivable';
            })
        }
    } catch (error) {
        dispatch({ type: UPDATE_RECEIVABLE_FAIL, payload: error.message })
    }
}

export const createReceivable = (createReceivableData) => async (dispatch) => {
    dispatch({ type: CREATE_RECEIVABLE_REQUEST });
    try {
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-receivables/create`, createReceivableData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: CREATE_RECEIVABLE_SUCCESS, payload: data });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/receivable';
            })
        }

    } catch (error) {
        dispatch({ type: CREATE_RECEIVABLE_FAIL, payload: error.message })
    }
}

export const getReceivables = (itemsPerPage, searchValue, activePage, id) => async (dispatch) => {
    dispatch({ type: GET_RECEIVABLE_REQUEST });
    try {
        if (id != null && id != undefined) {
            let headerData = {
                "api_token": localStorage.getItem('apiToken'),
                "customer_no": localStorage.getItem('customerNo'),
                "user_id": localStorage.getItem('userId'),
                "reference_number": id,
            }

            const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-receivables`, headerData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorage.getItem('apiToken'),
                    "Access-Control-Allow-Origin": "*"
                }
            });

            dispatch({ type: GET_RECEIVABLE_SUCCESS, payload: data });
        } else {
            let headerData = {
                "api_token": localStorage.getItem('apiToken'),
                "customer_no": localStorage.getItem('customerNo'),
                "user_id": localStorage.getItem('userId'),
                'itemPerPage': itemsPerPage,
                "searchString": searchValue,
            }
            const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-receivables?page=${activePage}`, headerData, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": localStorage.getItem('apiToken'),
                    "Access-Control-Allow-Origin": "*"
                }
            });

            dispatch({ type: GET_RECEIVABLE_SUCCESS, payload: data });
        }
    } catch (error) {
        dispatch({ type: GET_RECEIVABLE_FAIL, payload: error.message })
    }
}

export const getFilteredReceivables = (filteredData) => async (dispatch) => {
    dispatch({ type: GET_RECEIVABLE_REQUEST });
    try {
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/getRecievable`, filteredData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: GET_RECEIVABLE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_RECEIVABLE_FAIL, payload: error.message })
    }
}
